export default "__VITE_ASSET__18cae340__"